import { render, staticRenderFns } from "./TransactionMemo.vue?vue&type=template&id=7138bf0c&scoped=true&"
import script from "./TransactionMemo.vue?vue&type=script&lang=js&"
export * from "./TransactionMemo.vue?vue&type=script&lang=js&"
import style0 from "./TransactionMemo.vue?vue&type=style&index=0&id=7138bf0c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7138bf0c",
  null
  
)

export default component.exports